﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import BootstrapDatepicker from 'bootstrap-datepicker';
import language_da from '../../../../bower_components/bootstrap-datepicker/js/locales/bootstrap-datepicker.da';

require('typeahead-addresspicker');

import language from '../../../common/language';
import config from '../../../common/config';

import tpl_searchEventQuery from './tpl/searchEventQuery.html';
import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import * as Entities_Empty from '../../../lib/entities/empty';
    
export default Marionette.LayoutView.extend({
    getTemplate: function () {
        return tpl_searchEventQuery();
    },
    initialize: function () {
        //this.latitude = 0;
        //this.longitude = 0;

        this.app = this.options.app;
    },
    ui: {
        'searchEventQuery_btnSearch': '#searchEventQuery_btnSearch',
        'searchEventQuery_btnClear': '#searchEventQuery_btnClear',
        'searchEventQuery_selectRadius' : '#searchEventQuery_selectRadius',
        'searchEventQuery_inputAddress' : '#searchEventQuery_inputAddress',
        'searchEventQuery_inputInformation' : '#searchEventQuery_inputInformation',
        'searchEventQuery_datepicker' : '#searchEventQuery_datepicker',
    },
    events: {
        'click @ui.searchEventQuery_btnSearch': 'btnSearchClick',
        'click @ui.searchEventQuery_btnClear': 'btnClearClick'
    },
    onRender: function () {
        var self = this;

        this.ui.searchEventQuery_inputInformation.val(this.app.entities.models.searchEventQuery.attributes.Information);
        this.ui.searchEventQuery_inputInformation.val(this.app.entities.models.searchEventQuery.attributes.Information);
        this.ui.searchEventQuery_inputAddress.val(this.app.entities.models.searchEventQuery.attributes.Address);

        this.setupSelectRadius();
    },
    onAttach(){
        var self = this;

        this.addressPicker = new AddressPicker();
        this.ui.searchEventQuery_inputAddress.typeahead(null, { 
            displayKey: 'description',
            source: self.addressPicker.ttAdapter()
        });

        this.addressPicker.bindDefaultTypeaheadEvent(this.ui.searchEventQuery_inputAddress);
        $(this.addressPicker).on('addresspicker:selected', function (event, parsedGeocodeResult) {
            if ((parsedGeocodeResult.latitude != 0) && (parsedGeocodeResult.longitude != 0)) {
                self.app.entities.models.searchEventQuery.attributes.Latitude = parsedGeocodeResult.latitude;
                self.app.entities.models.searchEventQuery.attributes.Longitude = parsedGeocodeResult.longitude;

                self.app.entities.models.searchEventQuery.attributes.Address = self.ui.searchEventQuery_inputAddress.val();

                for (var i = 0; i < parsedGeocodeResult.placeResult.address_components.length; i++) {
                    if (parsedGeocodeResult.placeResult.address_components[i].types[0] == "country") {
                        self.app.entities.models.searchEventQuery.attributes.Country = parsedGeocodeResult.placeResult.address_components[i].long_name;
                    } 
                }
            }
        });

        /*var startDate = new Date();
        var strLocalStartDate = startDate.getDate().toString() + '/' + (startDate.getMonth() + 1) + '/' + startDate.getFullYear().toString();*/

        var lng = language.getLanguage_bootstrap_datePicker(config.cultureName());

        this.ui.searchEventQuery_datepicker.datepicker({
            autoclose: true,
            todayHighlight: true,
            language: lng
        }).on('changeDate', function (e) {
            self.app.entities.models.searchEventQuery.attributes.UtcStartDate = $(self.el).find('[name=start]').datepicker('getUTCDate');
            //self.app.entities.models.searchEventQuery.attributes.UtcEndDate = $(self.el).find('[name=end]').datepicker('getUTCDate');
        });
        //$(this.el).find('[name=start]').datepicker('setDate', strLocalStartDate);
        $(this.el).find('[name=start]').datepicker('setDate', this.app.entities.models.searchEventQuery.attributes.UtcStartDate);
        
    },
    setupSelectRadius() {
        this.ui.searchEventQuery_selectRadius.val(this.app.entities.models.searchEventQuery.attributes.Radius);
    },
    onDestroy(){
        $(this.addressPicker).unbind();
        this.ui.searchEventQuery_datepicker.datepicker("destroy");
    },
    btnClearClick: function (event) {
        if (event != null) {
            event.preventDefault();
        }

        this.ui.searchEventQuery_selectRadius.val('400000000');
        this.ui.searchEventQuery_inputInformation.val('');
        this.ui.searchEventQuery_inputAddress.val(resources.X100001);

        $(this.el).find('[name=start]').datepicker('setDate', '');
        $(this.el).find('[name=end]').datepicker('setDate', '');
    },
    btnSearchClick: function (event) {
        var dialogWaitingModel = new Entities_Empty.Model();
        dialogWaitingModel.attributes.Title = resources.X100027;
        dialogWaitingModel.attributes.Text = resources.X100029;
        dialogWaitingModel.attributes.Button = resources.X100279;

        var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
        app.dialogRegion.show(dialogWaiting);

        if (event != null) {
            event.preventDefault();
        }
        this.app.entities.collections.searchEvent.reset();
        this.app.entities.models.searchEventQuery.attributes.Radius = parseInt(this.ui.searchEventQuery_selectRadius.val());
        this.app.entities.models.searchEventQuery.attributes.Information = this.ui.searchEventQuery_inputInformation.val();

        var self = this;

        /*if (this.app.entities.models.searchEventQuery.attributes.CountryCode == resources.X100002) {
            this.app.entities.models.searchEventQuery.attributes.Latitude = 0;
            this.app.entities.models.searchEventQuery.attributes.Longitude = 0;
        }*/

        if (this.ui.searchEventQuery_inputAddress.val() == resources.X100001) {
            this.app.entities.models.searchEventQuery.attributes.Latitude = 0;
            this.app.entities.models.searchEventQuery.attributes.Longitude = 0;

            this.app.entities.models.searchEventQuery.attributes.Address = resources.X100001;
        }

        if ($('[name=start]').val() == '')
        {
            this.app.entities.models.searchEventQuery.attributes.UtcStartDate = null;
        }

        if (this.app.entities.models.searchEventQuery.attributes.UtcStartDate != null) {
            this.app.entities.models.searchEventQuery.attributes.UtcStartDate.setHours(0);
            this.app.entities.models.searchEventQuery.attributes.UtcStartDate.setMinutes(0);
            this.app.entities.models.searchEventQuery.attributes.UtcStartDate.setSeconds(1);

            var utcStartDate = this.app.entities.models.searchEventQuery.attributes.UtcStartDate.getUTCFullYear().toString() + '-' +
                   (this.app.entities.models.searchEventQuery.attributes.UtcStartDate.getUTCMonth() + 1) + '-' +
                    this.app.entities.models.searchEventQuery.attributes.UtcStartDate.getUTCDate().toString() + ' ' +
                    this.app.entities.models.searchEventQuery.attributes.UtcStartDate.getUTCHours() + ':' + 
                    this.app.entities.models.searchEventQuery.attributes.UtcStartDate.getUTCMinutes() + ':01';

            var self = this;
            this.app.entities.collections.searchEvent.fetch({
                first: false,
                information: encodeURIComponent(this.app.entities.models.searchEventQuery.attributes.Information),
                utcStartDate: utcStartDate,
                //utcEndDate: utcEndDate,
                latitude: this.app.entities.models.searchEventQuery.attributes.Latitude,
                longitude: this.app.entities.models.searchEventQuery.attributes.Longitude,
                radius: this.app.entities.models.searchEventQuery.attributes.Radius,
                maxRecord: 100,
                country: this.app.entities.models.searchEventQuery.attributes.Country,
                bust : new Date().getTime(),
                success: function (data) {
                    dialogWaiting.triggerMethod('dialog:close');

                    var timeout_id = setTimeout(function () {
                        document.body.className = document.body.className.replace("modal-open", "");
                        $('.modal.fade.show').remove();
                        $('.modal-backdrop').remove();
                        self.triggerMethod('rerender');
                    }, 1000);
                }
            });
        }
        else {
            this.app.entities.collections.searchEvent.fetch({
                first: false,
                information: encodeURIComponent(this.app.entities.models.searchEventQuery.attributes.Information),
                latitude: this.app.entities.models.searchEventQuery.attributes.Latitude,
                longitude: this.app.entities.models.searchEventQuery.attributes.Longitude,
                radius: this.app.entities.models.searchEventQuery.attributes.Radius,
                maxRecord: 100,
                country: this.app.entities.models.searchEventQuery.attributes.Country,
                bust : new Date().getTime(),
                success: function (data) {
                    dialogWaiting.triggerMethod('dialog:close');

                    var timeout_id = setTimeout(function () {
                        document.body.className = document.body.className.replace("modal-open", "");
                        $('.modal.fade.show').remove();
                        $('.modal-backdrop').remove();
                        self.triggerMethod('rerender');
                    }, 1000);
                }
            });
        }
    }
});